import { useWeb3React } from '@web3-react/core';
import useBlockNumber from 'hooks/useBlockNumber';
import { useInterfaceMulticall } from 'hooks/useContract';

import multicall from '.';

export function MulticallUpdater() {
  const { chainId } = useWeb3React();
  const latestBlockNumber = useBlockNumber();
  const contract = useInterfaceMulticall();

  return <multicall.Updater chainId={chainId} latestBlockNumber={latestBlockNumber} contract={contract} />;
}
